import React, { PureComponent } from 'react';
import { VirtualBrand } from '~/Api/Analytics/VirtualBrand';
import { Registration } from '~/Api/Analytics/VirtualBrand/Registration';
import ActivityIndicator from '~/UI/ActivityIndicator';
import { Link } from '~/UI/Button';

import styles from './styles.less';

interface Props {
	virtualBrand: VirtualBrand;
	isFetching: boolean;
	registration: Registration | null;
	formatDate(date: Date): string;
	onLoad(a: string): void;
}

export default class RegistrationTab extends PureComponent<Props> {
	componentDidMount() {
		const { virtualBrand, onLoad } = this.props;
		onLoad(virtualBrand.id);
	}

	render() {
		const { isFetching, registration, formatDate } = this.props;

		if (isFetching) {
			return <ActivityIndicator />;
		}
		if (!registration) {
			return null;
		}

		const { epar } = registration;

		return (
			<div className={styles.content}>
				{epar ? <h2 className={styles.heading}>EPAR</h2> : null}

				{epar ? (
					<div className={styles.table}>
						<div className={styles.row}>
							<div className={styles.name}>Category:</div>
							<div className={styles.value}>{epar.category}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Medicine name:</div>
							<div className={styles.value}>{epar.medicineName}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Therapeutic areas:</div>
							<div className={styles.value}>{epar.therapeuticAreas.join(', ')}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>International non proprietary name or common name:</div>
							<div className={styles.value}>{epar.internationalNonProprietaryNameOrCommonName}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Active substance:</div>
							<div className={styles.value}>{epar.activeSubstance}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Product number:</div>
							<div className={styles.value}>{epar.productNumber}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Patient safety:</div>
							<div className={styles.value}>{epar.patientSafety ? 'yes' : 'no'}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Authorisation status:</div>
							<div className={styles.value}>{epar.authorisationStatus}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>ATC code:</div>
							<div className={styles.value}>{epar.atcCode}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Additional monitoring:</div>
							<div className={styles.value}>{epar.additionalMonitoring ? 'yes' : 'no'}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Generic:</div>
							<div className={styles.value}>{epar.generic ? 'yes' : 'no'}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Biosimilar:</div>
							<div className={styles.value}>{epar.biosimilar ? 'yes' : 'no'}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Conditional approval:</div>
							<div className={styles.value}>{epar.conditionalApproval ? 'yes' : 'no'}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Previous medicine name:</div>
							<div className={styles.value}>{epar.previousMedicineName}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Exceptional circumstances:</div>
							<div className={styles.value}>{epar.exceptionalCircumstances ? 'yes' : 'no'}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Accelerated assessment:</div>
							<div className={styles.value}>{epar.acceleratedAssessment ? 'yes' : 'no'}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Orphan medicine:</div>
							<div className={styles.value}>{epar.orphanMedicine ? 'yes' : 'no'}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Marketing authorisation date:</div>
							<div className={styles.value}>
								{epar.marketingAuthorisationDate ? formatDate(epar.marketingAuthorisationDate) : null}
							</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Date of refusal of marketing authorisation:</div>
							<div className={styles.value}>
								{epar.dateOfRefusalOfMarketingAuthorisation
									? formatDate(epar.dateOfRefusalOfMarketingAuthorisation)
									: null}
							</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Marketing authorisation holder or company name:</div>
							<div className={styles.value}>{epar.marketingAuthorisationHolderOrCompanyName}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Human pharmacotherapeutic group:</div>
							<div className={styles.value}>{epar.humanPharmacotherapeuticGroup}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Date of opinion:</div>
							<div className={styles.value}>{epar.dateOfOpinion ? formatDate(epar.dateOfOpinion) : null}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Decision date / number:</div>
							<div className={styles.value}>
								{epar.decisionDate ? formatDate(epar.decisionDate) : null} / {epar.revisionNumber}
							</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Condition / indication:</div>
							<div className={styles.value}>{epar.conditionOrIndication}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>First published:</div>
							<div className={styles.value}>{formatDate(epar.firstPublished)}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>Revision date:</div>
							<div className={styles.value}>{epar.revisionDate ? formatDate(epar.revisionDate) : null}</div>
						</div>
						<div className={styles.row}>
							<div className={styles.name}>URL:</div>
							<div className={styles.value}>
								<Link href={epar.url} rel='noreferrer' styles={styles}>
									{epar.url}
								</Link>
							</div>
						</div>
					</div>
				) : null}
			</div>
		);
	}
}
